const packages = [
    {label: "אמסטרדם", airport_code: "amsterdam-package", value: 1},
    {label: "בודפשט", airport_code: "budapest-package", value: 2},
    {label: "בוקרשט", airport_code: "bucharest-package", value: 3},
    {label: "בנגקוק", airport_code: "bangkok-package", value: 4},
    {label: "ניו יורק", airport_code: "NEW-YORK-package", value: 9},
    {label: "פראג", airport_code: "prague-package", value: 1133},
    {label: "גארדה", airport_code: "garda-package", value: 11},
    {label: "ונציה", airport_code: "venice-package", value: 12},
    {label: "ורונה", airport_code: "verona-package", value: 13},
    {label: "טוסקנה", airport_code: "tuscany-package", value: 14},
    {label: "מילאנו", airport_code: "milan-package", value: 15},
    {label: "סיציליה", airport_code: "sicily-package", value: 16},
    {label: "רומא", airport_code: "rome-package", value: 17},
    {label: "אתונה", airport_code: "athens-package", value: 18},
    {label: "כרתים- הרקלין", airport_code: "crete-package", value: 19},
    {label: "כרתים- חאניה", airport_code: "crete-chania-package", value: 110},
    {label: "מיקונוס", airport_code: "mykonos-package", value: 111},
    {label: "סנטוריני", airport_code: "santorini-package", value: 112},
    {label: "קוס", airport_code: "kos-package", value: 113},
    {label: "רודוס", airport_code: "rhodes-package", value: 114},
    {label: "קורפו", airport_code: "corfu-package", value: 115},
    {label: "ברלין", airport_code: "berlin-package", value: 116},
    {label: "דיסלדורף", airport_code: "dusseldorf-package", value: 117},
    {label: "המבורג", airport_code: "hamburg-package", value: 118},
    {label: "יער שחור", airport_code: "black-forest-package", value: 119},
    {label: "מינכן", airport_code: "munich-package", value: 120},
    {label: "פרנקפורט", airport_code: "frankfurt-package", value: 121},
    {label: "ברצלונה", airport_code: "barcelona-package", value: 122},
    {label: "ולנסיה", airport_code: "valencia-package", value: 123},
    {label: "טנריף", airport_code: "tenerife-package", value: 124},
    {label: "מדריד", airport_code: "madrid-package", value: 125},
    {label: "מלאגה", airport_code: "malaga-package", value: 126},
    {label: "ניס", airport_code: "nice-package", value: 127},
    {label: "פרובנס", airport_code: "provence-package", value: 128},
    {label: "פריז", airport_code: "paris-package", value: 129},
    {label: "דבלין", airport_code: "dublin-package", value: 130},
    {label: "לונדון", airport_code: "london-package", value: 131},
    {label: "מנצ'סטר", airport_code: "manchester-package", value: 132},
    {label: "אוסלו", airport_code: "oslo-package", value: 133},
    {label: "איסטנבול", airport_code: "istanbul-package", value: 134},
    {label: "אנטליה", airport_code: "antalya-package", value: 135},
    {label: "בורגס", airport_code: "burgas-package", value: 136},
    {label: "בלגרד", airport_code: "belgrade-package", value: 137},
    {label: "בריסל", airport_code: "brussels-package", value: 138},
    {label: "דיסני", airport_code: "disney-package", value: 139},
    {label: "וילנה", airport_code: "vilnius-package", value: 140},
    {label: "וינה", airport_code: "vienna-package", value: 141},
    {label: "ורנה", airport_code: "varna-package", value: 142},
    {label: "ורשה", airport_code: "warsaw-package", value: 143},
    {label: "ז'נבה", airport_code: "geneva-package", value: 144},
    {label: "טביליסי", airport_code: "tbilisi-package", value: 145},
    {label: "לאס וגאס", airport_code: "las-vegas-package", value: 146},
    {label: "ליסבון", airport_code: "lisbon-package", value: 147},
    {label: "לרנקה", airport_code: "larnaca-package", value: 148},
    {label: "מוסקבה", airport_code: "moscow-package", value: 149},
    {label: "מיאמי", airport_code: "miami-package", value: 150},
    {label: "מלטה", airport_code: "malta-package", value: 151},
    {label: "סופיה", airport_code: "sofia-package", value: 153},
    {label: "סנט פטרסבורג", airport_code: "saint-petersburg-package", value: 154},
    {label: "פאפוס", airport_code: "paphos-package", value: 155},
    {label: "פוקט", airport_code: "phuket-package", value: 156},
    {label: "פראג", airport_code: "prague-package", value: 157},
    {label: "ציריך", airport_code: "zurich-package", value: 158},
    {label: "קופנהגן", airport_code: "copenhagen-package", value: 159},
    {label: "ריגה", airport_code: "riga-package", value: 160},
    {label: "שטוקהולם", airport_code: "stockholm-package", value: 161},
    {label: "מלדיביים", airport_code: "maldives-package", value: 162},
    {label: "באקו", airport_code: "baku-package", value: 163}
]

export default packages;


// WEBPACK FOOTER //
// ./src/packages.js